import {useState} from 'react'
import {getService} from '../services'
import {ServiceModel, SelectModel} from '../model'
import {mapDataSelect} from '../../../util/functions'
const useServiceList = () => {
  const [loading, setLoading] = useState(false)
  const [serviceList, setServiceList] = useState<SelectModel[]>([])

  const getServiceAPI = async (serviceParams: ServiceModel) => {
    let obj: ServiceModel = {
      isCombo: true,
      ...serviceParams,
    }
    return await getService(obj, 1)
  }

  const getServiceData = async (serviceParams: ServiceModel) => {
    setLoading(true)
    try {
      const response = await getServiceAPI(serviceParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching service data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const updateServiceList = (mappedSites: {value: string; label: string}[]) => {
    setServiceList(mappedSites)
  }
  const getServiceMappedData = async (serviceParams: ServiceModel) => {
    try {
      const data = await getServiceData(serviceParams)
      const mappedSites = mapDataSelect(data)
      return mappedSites
    } catch (error) {
      console.error('Error fetching service data:', error)
    }
  }
  const getServiceList = async (serviceParams: ServiceModel = {}) => {
    try {
      const data = await getServiceData(serviceParams)
      const mappedSites = mapDataSelect(data)
      updateServiceList(mappedSites)
    } catch (error) {
      console.error('Error fetching service data:', error)
    }
  }

  const handleClear = () => {
    setServiceList([])
  }

  return {
    loading,
    serviceList,
    getServiceList,
    handleClear,
    getServiceMappedData,
  }
}

export default useServiceList
